import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import { setCookie, getCookie, delCookie } from "./components/js/cookie.js";
import Storage from "./components/js/storage.js";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import "./assets/iconfont/iconfont.css";
import echarts from "echarts";

Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = axios;
Vue.prototype.setCookie = setCookie;
Vue.prototype.getCookie = getCookie;
Vue.prototype.delCookie = delCookie;
Vue.prototype.Storage = Storage;
Vue.prototype.isIdCard = (id) => {
  // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
  var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
  //号码规则校验
  if (!format.test(id)) {
    Vue.prototype.$message.error("身份证号码不合规!，请重新输入");
    return false;
  }
  //区位码校验
  //出生年月日校验  前正则限制起始年份为1900;
  var year = id.substr(6, 4), //身份证年
    month = id.substr(10, 2), //身份证月
    date = id.substr(12, 2), //身份证日
    time = Date.parse(month + "-" + date + "-" + year), //身份证日期时间戳date
    now_time = Date.parse(new Date()), //当前时间戳
    dates = new Date(year, month, 0).getDate(); //身份证当月天数
  if (time > now_time || date > dates) {
    Vue.prototype.$message.error("出生日期不合规!，请重新输入");
    return false;
  }
  //校验码判断
  var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
  var b = new Array("1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"); //校验码对照表
  var id_array = id.split("");
  var sum = 0;
  for (var k = 0; k < 17; k++) {
    sum += parseInt(id_array[k]) * parseInt(c[k]);
  }
  if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
    Vue.prototype.$message.error("身份证号码错误!，请重新输入");
    return false;
  }
  return true;
};
import Router from "vue-router";
import { format } from "url";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
//  setCookie("loginid",'eyJ0eXAiOiJqd3QiLCJhbGciOiJIUzI1NiJ9.IjEi.CvcIv0Uq4D4RED7cyYGVCSoWnLGpA8_fFTddsQZ_cjk');
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  if (!getCookie("loginid")) {
    if (
      to.meta.auth != "Admin" &&
      to.name != "entrance" &&
      to.meta.auth != "car" &&
      to.name != "ToPractice"
    ) {
      next("/entrance/" + to.params.id);
    }
    if (to.meta.auth == "car") {
      window.location.href = "http://custom.netban.cn/app/?id=T17220";
    }
    if (to.name == "entrance") {
      next();
    }
    if (to.name == "ToPractice") {
      next();
    }
    if (to.path == "/login" && to.meta.auth == "Admin") {
      next();
    }

    if (to.path != "/login" && to.meta.auth == "Admin") {
      next("/login");
    }
  }
  next();
});

Vue.directive("focus", {
  inserted: function(el, binding) {
    if (binding.value) {
      if (el.tagName.toLocaleLowerCase() == "input") {
        el.focus();
      } else {
        if (el.getElementsByTagName("input")) {
          el.getElementsByTagName("input")[0].focus();
        }
      }
    }
  },
});

axios.interceptors.request.use((config) => {
  if (getCookie("loginid")) {
    //每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    config.headers.token = getCookie("loginid");
  }

  if (config.url.indexOf("/api/admin/") != -1) {
    //考试后台传numbers
    if (Storage.getStorage("orgNumber")) {
      config.headers.numbers = Storage.getStorage("orgNumber");
    }
    if (getCookie("jid")) {
      config.headers.numbers = getCookie("jid");
    }
  }
  return config;
});
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // router.replace({
    //   path: "/404"
    // });

    return Promise.reject(error.response.data);
  }
);
Vue.fromUrl = "http://ks.netban.cn";
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
